<template>
  <a-layout class="login-layout">
    <a-layout-content style="background:#F2F2F2">
      <router-view />
    </a-layout-content>
    <Footer style="background: rgb(242, 242, 242);" />
  </a-layout>
</template>

<script>
import Footer from '@/components/Footer'
export default {
  name: 'InsideLayout',
  components: {
    Footer
  }
}
</script>

<style lang="less" scoped>
.login-layout {
  .ant-layout-content {
    width: 100%;
    overflow: hidden;
    min-width: 1200px;
    background-size: cover;
  }
}
</style>
